// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1BOTF","image":"Header_image__1a-sn","name":"Header_name__1eU_p","info":"Header_info__2rveC","infoRow":"Header_infoRow__3B-bs"};